import * as error from "./api/error";
import * as queryStringHelpers from "./queryStringHelpers";
import {useEffect} from "react";

const FILE_NAME = "useLeadsRX";

type ExtendedWindow = Window & {
    _lab: string[];
    _lrx_sendEvent: (key: string, code: number, id: string, profile: string) => void;
};

const EVENT_KEY = "leadsrx_event";

function getEventId(lrxCode: number, dsn: string): string {
    return `leads_${lrxCode}_${dsn}`;
}

function safeSetItem(key: string, value: string) {
    try {
        localStorage.setItem(key, value);
    } catch (err) {
        error.reportUnknown(err, FILE_NAME);
    }
}

function safeGetItem(key: string): string | null {
    try {
        return localStorage.getItem(key);
    } catch (err) {
        error.reportUnknown(err, FILE_NAME);
        return null;
    }
}

export default function useLeadsRX(lrxCode: number) {
    useEffect(() => {
        const qs = queryStringHelpers.objectify(window.location.search);
        const dsn = qs[queryStringHelpers.Keys.DSN];

        if (!lrxCode || !dsn) {
            return;
        }

        const eventId = getEventId(lrxCode, dsn);
        const lastEventId = safeGetItem(EVENT_KEY);

        const addScript = qs.m !== "300" && eventId !== lastEventId;

        let lab: HTMLScriptElement | null = null;
        if (addScript) {
            lab = document.createElement("script");
            const extendedWindow = (window as unknown) as ExtendedWindow;
            extendedWindow._lab.push(process.env.REACT_APP_LEADS_RX_ID as string);

            lab.type = "text/javascript";
            lab.async = true;
            lab.crossOrigin = "anonymous";
            lab.integrity =
                "sha384-Ftj7fPpsmLWGtqw84cvcWhoKEaSa6/lrepyaIOfR26m/+vQeG04VitjvMPFDt5IK";
            lab.src = "https://app.leadsrx.com/secure/visitor-ffb.js";
            lab.onload = () => {
                const _lrx_profile = {
                    userID: dsn,
                };

                let _lrx_timer: NodeJS.Timeout | null = null;
                function sendConversion() {
                    if (typeof extendedWindow._lrx_sendEvent === "undefined") {
                        return;
                    }
                    if (_lrx_timer !== null) {
                        clearTimeout(_lrx_timer);
                    }
                    extendedWindow._lrx_sendEvent(
                        "conversion",
                        lrxCode,
                        dsn,
                        JSON.stringify(_lrx_profile),
                    );

                    safeSetItem(EVENT_KEY, eventId);
                }
                _lrx_timer = setTimeout(sendConversion, 3000);
            };
            document.body.appendChild(lab);
        }

        return () => {
            if (lab) {
                document.body.removeChild(lab);
            }
        };
    }, [lrxCode]);
}
